import { render, staticRenderFns } from "./WageReview.vue?vue&type=template&id=e235391a&scoped=true&"
import script from "./WageReview.vue?vue&type=script&lang=js&"
export * from "./WageReview.vue?vue&type=script&lang=js&"
import style0 from "./WageReview.vue?vue&type=style&index=0&id=e235391a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e235391a",
  null
  
)

export default component.exports